import { useLinkProps } from '@react-navigation/native';
import { useCallback } from 'react';
import { isBrowser } from 'src/utils/platform';
export default function useNavPressableLink({ to, onPress, disabled, }) {
    const { href, onPress: linkOnPress, accessibilityRole, } = useLinkProps({ to });
    const mergedOnPress = useCallback((e) => {
        onPress?.(e);
        linkOnPress(e);
    }, [linkOnPress, onPress]);
    const useWebHref = isBrowser && !disabled;
    return {
        onPress: mergedOnPress,
        href: useWebHref ? href : undefined,
        accessibilityRole: useWebHref ? accessibilityRole : undefined,
    };
}
